import { useSearchParams } from 'react-router-dom';

export const usePricesFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const priceFrom = searchParams.get('price_from');
  const priceTo = searchParams.get('price_to');
  const priceFromNumber = priceFrom ? Number(priceFrom) : undefined;
  const priceToNumber = priceTo ? Number(priceTo) : undefined;

  const setPrices = (price_from?: string, price_to?: string) => {
    setSearchParams(searchParams => {
      if (price_from) {
        searchParams.set('price_from', price_from);
      } else {
        searchParams.delete('price_from');
      }
      if (price_to) {
        searchParams.set('price_to', price_to);
      } else {
        searchParams.delete('price_to');
      }
      return searchParams;
    });
  };

  return {
    priceFrom,
    priceTo,
    setPrices,
    priceFromNumber,
    priceToNumber,
    urlPrices: `${priceFrom ? `?price_from=${priceFrom}` : ''}${
      priceTo ? `${priceFrom ? '&' : '?'}price_to=${priceTo}` : ''
    }`,
  };
};
